const invertedMessages = {
  'Are you sure you want to enable identity verification?':
    'external.idp.enable.confirmationIV',
  'Third party cost may be incurred.': 'external.idp.enable.subtext',
  Apply: 'external.idp.apply',
  Cancel: 'external.idp.cancel',
  'Are you sure you want to disable identity verification?':
    'external.idp.disable.titleIV',
  Disable: 'external.idp.disable',
  Enable: 'external.idp.enable',
  'Data Fetch Error': 'external.idp.dataError',
  'Identity Verification': 'external.idp.identityVerification',
  'Set Up': 'external.idpSetup.setUpBtn',
  Disabled: 'external.idp.status.disabled',
  Enabled: 'external.idp.status.enabled',
  Settings: 'external.idp.tab.settings',
};

export default invertedMessages;
